import {assign} from '../ponyfills/assign';

const config = {};

const jsonHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
};

const methods = {
  del: 'DELETE',
  get: 'GET',
  patch: 'PATCH',
  post: 'POST',
  put: 'PUT',
};

const types = {
  json: 'json',
  text: 'text',
};

class HttpService {
  getContent(uri, type = types.text, headers) {
    return errorHandler(fetch(uri, assign({
      method: methods.get,
      headers: headers || {},
    }, config)), type);
  }

  getJson(uri, headers) {
    return this.getContent(uri, types.json, headers);
  }

  postText(uri, type = types.text, body, headers = {}, method = methods.post) {
    return errorHandler(fetch(uri, assign({
      method,
      headers,
      body,
    }, config)), type);
  }

  patchText(uri, type = types.text, body, headers = {}) {
    return this.postText(uri, type, body, headers, methods.patch);
  }

  putText(uri, type = types.text, body, headers = {}) {
    return this.postText(uri, type, body, headers, methods.put);
  }

  delText(uri, type = types.text, body, headers = {}) {
    return this.postText(uri, type, body, headers, methods.del);
  }

  postJson(uri, body, method, headers) {
    return this.postText(uri, types.json, JSON.stringify(body), headers, method);
  }

  patchJson(uri, body, headers) {
    return this.postJson(uri, body, methods.patch, headers);
  }

  putJson(uri, body, headers) {
    return this.postJson(uri, body, methods.put, headers);
  }

  delJson(uri, body, headers) {
    return this.postJson(uri, body, methods.del, headers);
  }

  postJsonPreflight(uri, body, method) {
    return this.postText(uri, types.json, JSON.stringify(body), jsonHeaders, method);
  }

  patchJsonPreflight(uri, body) {
    return this.postJsonPreflight(uri, body, methods.patch);
  }

  putJsonPreflight(uri, body) {
    return this.postJsonPreflight(uri, body, methods.put);
  }

  delJsonPreflight(uri, body) {
    return this.postJsonPreflight(uri, body, methods.del);
  }

  postJsonRawContent(uri, body, headers, method) {
    return this.postText(uri, types.text, JSON.stringify(body), headers, method);
  }

  patchJsonRawContent(uri, body, headers) {
    return this.postJsonRawContent(uri, body, headers, methods.patch);
  }

  putJsonRawContent(uri, body, headers) {
    return this.postJsonRawContent(uri, body, headers, methods.put);
  }

  delJsonRawContent(uri, body, headers) {
    return this.postJsonRawContent(uri, body, headers, methods.del);
  }
}

export const http = new HttpService();

/**
 * @param promise
 * @param type
 */
function errorHandler(promise, type) {
  const tmp = {};

  return promise.then((res) => {
    tmp.res = res;

    return res[type]().catch(() => ({}));
  }).then((data) => {
    if (tmp.res.ok) {
      return data;
    }

    if (type === types.json) {
      data.status = tmp.res.status;
    }

    throw data;
  });
}

/**
 * @param option
 */
export function setCredentials(option = 'include') {
  config.credentials = option;
}
